const API_URL = import.meta.env.VITE_APP_API_URL

export function resolveApiMediaUrl(url: string | null | undefined): string | null {
	if (!url) return null
	const trimmed = url.trim()
	if (!trimmed) return null
	if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("data:")) {
		return trimmed
	}
	const path = trimmed.startsWith("/") ? trimmed.slice(1) : trimmed
	return `${API_URL}${path}`
}

export async function fetchMediaAsFile(url: string | null | undefined): Promise<File | null> {
	const resolved = resolveApiMediaUrl(url)
	if (!resolved) return null
	const response = await fetch(resolved)
	if (!response.ok) return null
	const blob = await response.blob()
	const filename = resolved.split("/").pop()?.split("?")[0] || "logo"
	return new File([blob], filename, { type: blob.type || "image/png" })
}
